
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function OutletPage() {
  useEffect(() => {
    updateSEO({
      ...seoData.outlet,
      canonical: `${getBaseURL()}/outlet`,
      ogTitle: seoData.outlet.title,
      ogDescription: seoData.outlet.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Maior Desconto');

  const filters = ['Todos', 'Masculino', 'Feminino', 'Acessórios', 'Bags', 'Watches'];
  const sortOptions = ['Maior Desconto', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/85f805cb9aa1a418adbd589a48d80225.jpg',
      brand: 'DLUXMEN',
      name: 'Camisa Premium Outlet',
      price: 'R$ 89,90',
      originalPrice: 'R$ 189,90',
      isNew: false
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20dress%20premium%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20dress%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-dress-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Vestido Elegante Outlet',
      price: 'R$ 149,90',
      originalPrice: 'R$ 299,90',
      isNew: false
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20bag%20premium%20leather%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20bag%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-bag-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Bolsa Premium Outlet',
      price: 'R$ 199,90',
      originalPrice: 'R$ 459,90',
      isNew: false
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20watch%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20watch%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-watch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Relógio Premium Outlet',
      price: 'R$ 399,90',
      originalPrice: 'R$ 899,90',
      isNew: false
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20polo%20premium%20cotton%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20polo%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-polo-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Polo Premium Outlet',
      price: 'R$ 79,90',
      originalPrice: 'R$ 159,90',
      isNew: false
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20blazer%20premium%20fabric%20with%20sophisticated%20tailoring%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20blazer%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-blazer-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Blazer Premium Outlet',
      price: 'R$ 249,90',
      originalPrice: 'R$ 549,90',
      isNew: false
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20accessories%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20accessories%20with%20emerald%20green%20brand%20accents%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-acc-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Acessórios Premium Outlet',
      price: 'R$ 59,90',
      originalPrice: 'R$ 129,90',
      isNew: false
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20outlet%20pants%20premium%20fabric%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20discounted%20pants%20with%20emerald%20green%20brand%20details%2C%20high-end%20quality%20at%20reduced%20price&width=400&height=500&seq=dluxmen-outlet-pants-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Calça Premium Outlet',
      price: 'R$ 119,90',
      originalPrice: 'R$ 249,90',
      isNew: false
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Outlet
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Produtos premium com descontos especiais - Oportunidades únicas
          </p>
        </div>
      </section>

      {/* Promotion Banner */}
      <section className="py-8" style={{ backgroundColor: '#0F3F2F' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="text-center">
            <h2 
              className="text-3xl font-bold text-white mb-2 max-md:text-2xl"
              style={{ fontFamily: 'Cinzel Decorative, serif' }}
            >
              🔥 OUTLET ESPECIAL
            </h2>
            <p 
              className="text-white/90 text-lg max-md:text-base"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Até 70% OFF • Produtos premium • Estoque limitado
            </p>
          </div>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
